import React from 'react';
import { useSelector } from 'react-redux';
import BulkUploadListFilters from '../components/BulkUploadListFilters';
import TopBar from '../../../components/TopBar';
import BulkUploadTable from '../components/BulkUploadTable';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Stack } from '@mui/material';
import FeatureNotSupportedDialog from '../../common/FeatureNotSupportedDialog';
import useBulkUploadFilters from '../../../components/filters/BulkUploadFilterHelper';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const CATEGORY_FILTER_OPTIONS = ['ALL', 'SALES_DOCUMENTS', 'PURCHASE_DOCUMENTS', 'CUSTOMER', 'SUPPLIER', 'PRODUCT'];

function BulkUploadListPage() {
  const { bulkUpload } = useTranslatedMessages();

  const placeholders = bulkUpload?.filters?.search_placeholders ?? {};

  const page = bulkUpload?.page ?? {};

  useDocumentTitle(page?.document_title ?? 'Bulk Upload List');

  const subscription = useSelector((state) => state.subscription.subscription);

  const user = useSelector((/** @type {any} */ state) => state.user.user);

  const isOrganizationOwner = Array.isArray(user?.roles) && user.roles.includes('ORGANIZATION_OWNER');

  const isBulkUploadFeatureEnabled = subscription?.features?.enable_bulk_upload;

  const isSftpFeatureEnabled = subscription?.features?.enable_sftp;

  const {
    searchTerm,
    selectedFilter,
    selectedStatus,
    selectedCategory,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleDateRangeChange,
    handlePaginationChange,
    handleStatusChange,
    handleCategoryChange,
  } = useBulkUploadFilters({
    persistKey: 'bulk-upload',
  });

  const filters = [
    {
      type: 'search',
      options: [
        {
          key: 'filename',
          placeholder: placeholders.filename ?? 'File Name',
        },
      ],
    },
  ];

  return isBulkUploadFeatureEnabled || isSftpFeatureEnabled ? (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title={page?.top_bar_title ?? 'Bulk Upload'} />

      <BulkUploadListFilters
        filters={filters}
        selectedFilter={selectedFilter}
        selectedStatus={selectedStatus}
        onFilterChange={handleFilterChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSearchKeyPress={handleSearchKeyPress}
        onDateRangeChange={handleDateRangeChange}
        onStatusChange={handleStatusChange}
        showCategoryFilter
        selectedCategory={selectedCategory}
        onCategoryChange={handleCategoryChange}
        categoryFilterOptions={CATEGORY_FILTER_OPTIONS}
      />

      <BulkUploadTable
        handlePaginationChange={handlePaginationChange}
        searchQuery={currentQuery}
        showCreatedBy={isOrganizationOwner}
      />
    </Stack>
  ) : (
    <FeatureNotSupportedDialog
      title={page?.feature_not_supported?.title ?? 'Bulk Upload'}
      description={
        page?.feature_not_supported?.description ??
        'Upload and process multiple documents simultaneously, saving time and streamlining your workflow.'
      }
    />
  );
}

export default BulkUploadListPage;
